import Vue from 'vue'
import Vuex from 'vuex'
import notifications from './modules/notifications'
import gridSelections from './modules/gridSelections'

Vue.use(Vuex)

const store = new Vuex.Store({
    actions: {},
    getters: {},
    modules: {
        notifications,
        gridSelections
    },
    strict: false
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js